import React from 'react';
import './Loading.css';

const Loading = () => (
    <div className="loading-container">
        <div className="loading-spinner">
            <div className="spinner"></div>
            <span>Loading...</span>
        </div>
    </div>
);

export default Loading;
